import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import Player from '@vimeo/player';

@Component({
  selector: 'app-vimeo-player',
  templateUrl: './vimeo-player.component.html',
  styleUrl: './vimeo-player.component.scss',
})
export class VimeoPlayerComponent implements AfterViewInit {
  @Input() videoUrl!: string;
  @ViewChild('playerContainer') playerContainer!: ElementRef;

  options: Player.Options = {
    autoplay: true,
    controls: false,
    keyboard: false,
    muted: true,
  };

  constructor() {}

  ngAfterViewInit() {
    const player = new Player(this.playerContainer.nativeElement, {
      url: this.videoUrl,
      ...this.options,
    });
    player.play().then(() => {
      // console.log('Vimeo Play');
    });
  }
}
